import {CompanyLabels, FeatureFlags, LayoutConfig, RoleConfig} from '../types';

/**
 * Default labels - used as fallback for any company type
 */
export const defaultLabels: CompanyLabels = {
  order: 'Order',
  orders: 'Orders',
  customer: 'Customer',
  customers: 'Customers',
  worker: 'Worker',
  workers: 'Mobile Workers',
  dispatch: 'Dispatch',
  landlord: 'Landlord',
  property: 'Property',
  properties: 'Properties',
  payment: 'Payment',
  deliveries: 'Deliveries',
};

/**
 * Default feature flags - all disabled by default
 */
export const defaultFeatures: FeatureFlags = {
  hasOfferingTypeFilterOnOrders: false,
  hasLandlordFilterOnOrders: false,
  hasPropertyNameFilterOnOrders: false,
  hasPropertyAddressFilterOnOrders: false,
  hasServiceOnOrderCreation: false,
  hasJobDescriptionOnOrderCreation: false,
  hasOrderTypeOnOrderDetails: false,
  hasLinkedOrderOnOrderDetails: false,
  hasPurchaseOrderOnOrderDetails: false,
  hasMoneyOutOnOrderDetails: false,
  hasMoneyInOnOrderDetails: false,
  hasPropertyDetailsOnOrderDetails: false,
  hasServicesOnOrderDetails: false,
  hasJobDescriptionOnOrderDetails: false,
  hasCostAndProfitOnOrderDetails: false,
  hasPaymentMethodOnCharge: false,
  hasPayerTypeOnCharge: false,
  hasPayerNameOnCharge: false,
  hasManagedPropertiesOnCompanyDetails: false,
  hasProductsOnOfferings: false,
  hasServicesOnOffering: false,
  hasShopifyIntegration: false,
  hasLandlordFilterOnCustomers: false,
  hasPropertyFilterOnCustomers: false,
  hasPayerTypeFilter: false,
  hasClientRoleFilterOnCustomers: false,
  hasOrderTypeOnTransactionDetails: false,
  hasMergeOrdersOnOrderList: false,
  hasOrderTypeSelectOnOrderCreation: false,
};

/**
 *
 */
export const defaultLayoutConfig: LayoutConfig = {
  orderDetailsSequence: [],
  prescriptionsSequence: [],
  resellerContentSequence: [],
};

/**
 * Base roles available to all company types
 */
export const baseRoles: RoleConfig[] = [
  {
    value: 'management',
    label: 'Manager',
    description: 'control access, billing plan, and view whole system',
  },
  {
    value: 'dispatcher',
    label: 'Dispatch',
    description: 'assemble field team and organize routes',
  },
  {
    value: 'tech',
    label: 'Operations',
    description: 'prepare orders to be "Ready for Dispatch"',
  },
  {
    value: 'customer_service',
    label: 'Customer Service',
    description: 'confirms details and payment',
  },
];

/**
 * Helper to merge partial config with defaults
 */
export function mergeWithDefaults(
  labels?: Partial<CompanyLabels>,
  features?: Partial<FeatureFlags>,
  roles?: RoleConfig[],
  layoutConfig?: LayoutConfig
): {
  labels: CompanyLabels;
  features: FeatureFlags;
  roles: RoleConfig[];
  layoutConfig: LayoutConfig;
} {
  return {
    labels: {...defaultLabels, ...labels},
    features: {...defaultFeatures, ...features},
    roles: roles ?? baseRoles,
    layoutConfig: layoutConfig ?? defaultLayoutConfig,
  };
}
